import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submit'];

  initialize() {
    this.checkFields = this.checkFields.bind(this);
  }

  get requiredFields() {
    const requiredFields = Array.from(this.element.querySelectorAll('[required]')).filter((field) => !field.classList.contains('trix-input'));
    const radios = Array.from(this.element.querySelectorAll('input[type="radio"]'));
    return [...requiredFields, ...radios];
  }

  connect() {
    this.requiredFields.forEach((field) => {
      field.addEventListener('change', this.checkFields);
      field.addEventListener('click', this.checkFields);
      field.addEventListener('keyup', this.checkFields);
      field.addEventListener('keydown', this.checkFields);
    });

    this.checkFields();
  }

  disconnect() {
    this.requiredFields.forEach((field) => {
      field.removeEventListener('change', this.checkFields);
      field.addEventListener('click', this.checkFields);
      field.removeEventListener('keyup', this.checkFields);
      field.removeEventListener('keydown', this.checkFields);
    });
  }

  checkFields() {
    let anyEmptyFields = false;

    this.requiredFields.forEach((field) => {
      if (anyEmptyFields) {
        return;
      }

      if (field.type === 'radio') {
        let isRadioChecked = false;

        this.element.querySelectorAll(`[name="${field.name}"]`).forEach((radio) => {
          if (radio.checked) {
            isRadioChecked = true;
          }
        });

        anyEmptyFields = !isRadioChecked;
        return;
      }

      if (!field.value) {
        anyEmptyFields = true;
      }
    });

    this.submitTarget.disabled = anyEmptyFields;
  }
}
